export default "__VITE_ASSET__ab51b40f__"